import { CommonModule } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA, EventEmitter, forwardRef, Input, Output } from '@angular/core';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { InputNumberModule } from 'primeng/inputnumber';
import { TableModule } from 'primeng/table';

@Component({
  selector: 'app-custom-input-decimal',
  templateUrl: './custom-input-decimal.component.html',
  styleUrls: ['./custom-input-decimal.component.scss'],
  standalone: true,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CustomInputDecimalComponent),
      multi: true
    }
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [CommonModule, FormsModule, InputNumberModule, ReactiveFormsModule, TableModule]
})
export class CustomInputDecimalComponent implements ControlValueAccessor {

  onChange: (value: any) => void;
  onTouched = () => { };

  @Input() disabled: boolean = false;
  @Input() formControlName: string | number | null = null;
  @Input() labelText: string = "";
  @Input() maxFractionDigits: number = 2;
  @Input() recovery: boolean = false;
  @Input() required: boolean = false;
  @Input() value: number | null = null;
  @Output() onChangeNumber = new EventEmitter<number>();

  changeNumber() {
    const numberValue = this.value ? this.value : this.value = 0;
    this.onChange(numberValue);
    this.onTouched();
    this.onChangeNumber.emit(numberValue);
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  selectAllText(event: Event) {
    const input = event.target as HTMLInputElement;
    input.select();
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  writeValue(value: number | null): void {
    this.value = value;
  }


}
